import React from 'react'
import { styled } from '@mui/material/styles'
import { Box, Typography, Paper } from '@mui/material'
import { ReactComponent as PhoneIcon } from '../../../../common/icons/phoneIcon.svg'
import AudioPlayer from '../../../../common/components/AudioPlayer'

const deepfakeAudioMap = {
  CEO_PHISHING: process.env.PUBLIC_URL + '/sounds/deepfake_example.ogg',
  HR_PHISHING: process.env.PUBLIC_URL + '/sounds/deepfake_example.ogg',
  COLLEAGUE_PHISHING: process.env.PUBLIC_URL + '/sounds/deepfake_example.ogg'
}

const scriptNameMap = {
  CEO_PHISHING: 'CEO Phishing',
  HR_PHISHING: 'HR Phishing',
  COLLEAGUE_PHISHING: 'Colleague Phishing'
}

export default function DeepfakePreview({ metadata }) {
  const { callerName, deepfakeScript, phoneNumber } = metadata || {}
  const audioSrc = deepfakeAudioMap[deepfakeScript]

  return (
    <PhoneFrame>
      <PhoneHeader>
        {PhoneIcon && <PhoneIcon style={{ width: 20, height: 20 }} />}
        <Typography>{callerName || 'Unknown Caller'}</Typography>
      </PhoneHeader>
      <Box
        sx={{
          padding: '16px',
          backgroundColor: '#ffffff',
          height: '300px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        <Box>
          <CallInfo>
            <Typography variant='subtitle2'>Incoming call from:</Typography>
            <Typography variant='h6'>{callerName || 'Unknown Caller'}</Typography>
            <Typography variant='subtitle2'>Number: {phoneNumber || 'Unknown Number'}</Typography>
            <Typography variant='caption' color='textSecondary'>
              Script type: {scriptNameMap[deepfakeScript] || deepfakeScript || 'Unknown Script'}
            </Typography>
          </CallInfo>
        </Box>

        {audioSrc && (
          <Box sx={{ width: '100%', mb: 2 }}>
            <AudioPlayer src={audioSrc} />
          </Box>
        )}
      </Box>
    </PhoneFrame>
  )
}

const PhoneHeader = styled(Box)({
  backgroundColor: '#f7f7f7',
  color: '#444',
  padding: '10px 15px',
  borderTopLeftRadius: '12px',
  borderTopRightRadius: '12px',
  display: 'flex',
  alignItems: 'center',
  gap: '10px'
})

const PhoneFrame = styled(Box)({
  height: '500px',
  border: '1px solid #ddd',
  borderRadius: '12px',
  overflow: 'hidden',
  width: '500px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
})

const CallInfo = styled(Paper)({
  padding: '16px',
  borderRadius: '8px',
  backgroundColor: '#f9f9f9',
  marginBottom: '16px'
})
